<template>
  <v-container class="pa-0 info-cliente">
    <v-row justify="center">
      <v-col cols="11">
        <v-card elevation="10" class="darkGlass">
          <v-toolbar class="primaryGradient" dark flat tile dense height="auto">
            <v-toolbar-title class="titulo">
              Bienvenido/a
              <span>
                {{ conv.capitalizeString(userLogged.nombre) }}
              </span>
            </v-toolbar-title>
          </v-toolbar>
          
          <v-toolbar
            color="transparent"
            :class="[userLogged.b_castigado ? 'mt-0 pt-0' : 'mt-4']"
            tile
            height="40px"
            flat
          >
            <v-toolbar-title class="cabecera black--text">
              <v-icon color="primary" class="mr-2">
                mdi-account-details-outline
              </v-icon>
              Información Personal
            </v-toolbar-title>
          </v-toolbar>
          <v-divider
            color="primary"
            style="
              width: calc(100% - 32px);
              margin-left: 16px;
              border-width: 1px;
            "
          ></v-divider>
          <v-row
            align-content="center"
            justify="center"
            v-if="loading"
            class="my-1"
          >
            <v-col class="text-subtitle-1 text-center" cols="12">
              Cargando Datos
            </v-col>
            <v-col cols="6">
              <v-progress-linear
                color="primary"
                indeterminate
                rounded
                height="10"
              ></v-progress-linear>
            </v-col>
          </v-row>
          <div v-else>
            <v-list color="transparent">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary"> mdi-map-marker </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-subtitle>Dirección</v-list-item-subtitle>
                  <v-list-item-title
                    v-if="
                      user.direccion_particular &&
                      user.direccion_particular.trim().length > 0
                    "
                  >
                    {{ conv.capitalizeString(user.direccion_particular) }}
                  </v-list-item-title>
                  <v-list-item-title v-else>No hay registro</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary"> mdi-card-account-phone </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-subtitle>Teléfono Personal</v-list-item-subtitle>
                  <v-list-item-title
                    v-if="
                      user.telefono_particular &&
                      parseInt(user.telefono_particular.trim()) > 0
                    "
                    >{{ user.telefono_particular }}</v-list-item-title
                  >
                  <v-list-item-title v-else>No hay registro</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary"> mdi-phone </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-subtitle>Teléfono Notificaciones</v-list-item-subtitle>
                  <v-list-item-title
                    v-if="
                      user.telefono_notificaciones &&
                      user.telefono_notificaciones.trim().length > 0 &&
                      user.telefono_notificaciones !== '0'
                    "
                    >{{ user.telefono_notificaciones }}</v-list-item-title
                  >
                  <v-list-item-title v-else>No hay registro</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <template v-if="sameEmail">
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary"> mdi-email </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-subtitle
                      >Correo Personal - Notificaciones</v-list-item-subtitle
                    >
                    <v-list-item-title>
                      {{ user.email_personal }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-else>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary"> mdi-card-account-mail </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-subtitle>Correo Personal</v-list-item-subtitle>
                    <v-list-item-title
                      v-if="fn.validateEmail(user.email_personal)"
                      >{{ user.email_personal }}</v-list-item-title
                    >
                    <v-list-item-title v-else
                      >No hay registro</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary"> mdi-email </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-subtitle
                      >Correo de Notificaciones</v-list-item-subtitle
                    >
                    <v-list-item-title
                      v-if="fn.validateEmail(user.email_recado)"
                      >{{ user.email_recado }}</v-list-item-title
                    >
                    <v-list-item-title v-else
                      >No hay registro</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </div>
          <v-alert
            v-if="userLogged.b_castigado"
            outlined
            type="warning"
            dense
            icon="mdi-alert-circle"
            class="mb-2 mx-12 my-2"
          >
            {{ userLogged.msg_castigado }}
          </v-alert>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="11">
        <v-row justify="center" align="stretch">
          <v-col v-for="product in products" :key="product.type">
            <v-card height="100px" elevation="10" class="darkGlass">
              <v-toolbar color="primary" dark flat tile dense height="36px">
                <v-icon left>{{ product.icon }}</v-icon>
                <v-toolbar-title class="cabecera link-style">
                  <router-link :to="product.to">
                    {{ product.type }}
                  </router-link>
                </v-toolbar-title>
              </v-toolbar>
              <v-card-title class="productos pt-2 pb-0">
                <p class="flex text-center">
                  {{ product.status ? "$" + product.amount : "No posee" }}
                </p>
              </v-card-title>
              <v-card-subtitle
                class="flex text-center"
                v-if="product.status && product.type === 'Créditos'"
              >
                Total Adeudado
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <mora-dialog v-if="dialogoMora" />
  </v-container>
</template>
<script>
import auth from "@/auth/auth";
import conv from "@/services/conversores";
import fn from "@/services/funciones";
import MoraDialog from "@/components/inicio/MoraDialog.vue";
import { mapState } from "vuex";
export default {
  metaInfo: { title: "Inicio" },
  components: {
    "mora-dialog": MoraDialog,
  },
  data: function () {
    return {
      conv, 
      fn,
      user: null,
      metaInfo: { title: "Inicio" },
      products: [
        {
          type: "Créditos",
          status: false,
          amount: 0,
          icon: "mdi-credit-card",
          to: "creditos",
        },
        {
          type: "Cuenta capital",
          status: false,
          amount: 0,
          icon: "mdi-cash",
          to: "cuenta-capital",
        },
      ],
      loading: true,
    };
  },
  methods: {
    async getUserInfo() {
      await auth
        .userInfo(this.userLogged.id_cliente)
        .then((res) => {
          this.user = res.data;
          if (this.user.creditos > 0) {
            this.products[0].status = true;
            this.products[0].amount = this.user.monto_creditos;
          }
          if (this.user.capital > 0) {
            this.products[1].status = true;
            this.products[1].amount = this.user.monto_capital;
          }
        })
        .catch((error) => console.error(error));
    },
  },

  computed: {
    ...mapState(["dialogoMora"]),
    userLogged() {
      return auth.getUserLogged();
    },
    sameEmail() {
      let personal = this.user.email_personal;
      let notificaciones = this.user.email_recado;
      return (
        fn.validateEmail(personal) &&
        fn.validateEmail(notificaciones) &&
        personal === notificaciones
      );
    },
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 150;
        case "sm":
          return 100;
        case "md":
          return 50;
        case "lg":
          return 50;
        case "xl":
          return 50;
        default:
          return 50;
      }
    },
  },
  async mounted() {
    if (process.env.NODE_ENV !== "production") console.log(this.userLogged);
    this.loading = true;
    await this.getUserInfo();
    this.loading = false;
  },
};
</script>

<style scoped lang="css">
.titulo {
  font-size: 3.2vh;
  line-height: 40px;
  word-break: normal;
  font-weight: 300;
  white-space: normal;
}
.cabecera {
  font-weight: 300;
  font-size: 2.8vh;
  line-height: 3vh;
}
.productos {
  color: black;
  font-weight: 300;
  font-size: 2.5vh;
  line-height: 3vh;
}
</style>
